export default __webpack_public_path__ + "static/media/MyPortrait.0c4116fc.png";